module.exports = __webpack_public_path__ + "static/media/notification.e5d7b0ff.svg";